import React from 'react';
import PrivateRoute from './PrivateRoute';
import Navbar from '../components/layout/Navbar';
import HomePage from '../components/pages/HomePage';
import Login from '../components/pages/Login';
import Register from '../components/pages/Register';
import Alert from '../components/layout/Alert';
import {BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';
import NotFound from "../components/pages/NotFound";

const AppRoutes = () => {
    return (
        <BrowserRouter>
            {/*<Navbar/>*/}
            <Alert/>
                <Routes>
                    <Route exact path='/' element={<PrivateRoute><HomePage/></PrivateRoute>}/>
                    <Route exact path='/login' element={<Login/>}/>
                    <Route exact path='/register' element={<Register/>}/>
                    <Route path="/404" element={<NotFound />} />
                    <Route path='*' element={<Navigate to="/404" replace />}/>
                </Routes>
        </BrowserRouter>
    );
};

export default AppRoutes;